import { AbstractControl } from '@angular/forms';

function valida_run(run: number) {
    if (!isNaN(run)) {
        return calcula_dv(run);
    } else {
        return false;
    }
}

function calcula_dv(T: number) {
    var M = 0, S = 1;
    for (; T; T = Math.floor(T / 10)) S = (S + T % 10 * (9 - M++ % 6)) % 11;
    return S ? (S - 1).toString() : 'k';
}

export function ValidateRun(control: AbstractControl) {
    let runCompleto = '';
    let valid = false;

    if (control.value !== null && control.value !== undefined && control.value.length >= 8 && control.value.length <= 12) {
        runCompleto = control.value.split('-');
        valid = valida_run(Number(runCompleto[0])) === runCompleto[1] ? true : false;

        if (!valid) {
            return { invalidRun: true };
        }
    }
    return null;
}

